import { render, staticRenderFns } from "./totop.vue?vue&type=template&id=841985a6&"
import script from "./totop.vue?vue&type=script&lang=js&"
export * from "./totop.vue?vue&type=script&lang=js&"
import style0 from "./totop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports